
<div #modal class="endpointShift">
  <div class="endpointcard">
    <div class="endpointShiftDropdown BoilerRoom">
      <div class="persondropdown">
        <select class="form-select" aria-label="Default select example">
          <option selected="">{{'Current Shift' | translate}}</option>
        </select>
        <div class="dorpdownarrow">
          <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path id="tqqr674ada" d="m7.129 8 4.709 4.962L16.547 8l1.446 1.527-6.155 6.5-6.156-6.5z">
              </path>
            </defs>
            <use [attr.fill]="colors.primary" fill-rule="nonzero" xlink:href="#tqqr674ada"
            transform="translate(.683 .367)"></use>
          </svg>
        </div>
      </div>
    </div>

    <div class="endpointShiftNum mt-3 d-flex align-items-top justify-content-between">
      <div class="endpointShiftNumTitle">
        <h3>Endpoint 001</h3>
        <p>ID : 8797980</p>
      </div>
      <div class="endpointIcon">
        <img src="../../../../assets/images/ShiftIcon.png">
      </div>
    </div>

    <div class="youtubeDown mt-2 d-flex align-items-top justify-content-between">
      <div class="youtubeIcon">
        <img src="../../../../assets/images/youtube.png">
      </div>

      <div class="endpointShiftDropdown BoilerRoom">
        <div class="persondropdown">
          <select class="form-select" aria-label="Default select example">
            <option selected="">{{'Sampling Report' | translate}}</option>
          </select>
          <div class="dorpdownarrow">
            <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path id="tqqr674ada"
                d="m7.129 8 4.709 4.962L16.547 8l1.446 1.527-6.155 6.5-6.156-6.5z"></path>
              </defs>
              <use [attr.fill]="colors.primary" fill-rule="nonzero" xlink:href="#tqqr674ada"
              transform="translate(.683 .367)"></use>
            </svg>
          </div>
        </div>
      </div>
    </div>


    <div class="endpointShiftNum PmMpDetail mt-3 d-flex align-items-top justify-content-start">
      <div class="endpointShiftNumTitle">
        <p class="pb-1">PM2.5</p>
        <h3>51.64<sub>UG/M3</sub></h3>
      </div>
      <div class="endpointShiftNumTitle border-left pl-3 ml-3">
        <p class="pb-1">{{ 'Respirable PM' | translate }}</p>
        <h3>0 <sub>UG/M3</sub></h3>
      </div>
    </div>

    <!-- <div class="GraphSection my-4">

  </div> -->
  <div (resized)="onResized($event,chart,'end-point-chart')">
    <div id="end-point-chart" style="width: 100%; height: 400px"></div>
  </div>

  <div class="DetailView">
    <div class="detalviewTitle border-bottom">
      @if (chart && chart.data.length) {
        <h3 #modalDetailsClick (click)="endpointAllDetail()">{{'Detailed View' | translate}}
        </h3>
      }
    </div>
  </div>

  <div class="endpointShiftNum TemDevice mt-3 d-flex align-items-top justify-content-start border-bottom">
    <div class="endpointShiftNumTitle">
      <img src="../../../../assets/images/temprature.png" alt="">
      <p class="pb-1">{{'Temperature' | translate}}</p>
      <h3>29.89 0C</h3>
    </div>
    <div class="endpointShiftNumTitle border-left pl-4 ml-5">
      <img src="../../../../assets/images/huminity.png" alt="">
      <p class="pb-1">{{'Humidity' | translate}}</p>
      <h3>24.14%</h3>
    </div>
    <div class="endpointShiftNumTitle border-left pl-4 ml-5">
      <img src="../../../../assets/images/device.png" alt="">
      <p class="pb-1">{{'Device' | translate}}</p>
      <h3>{{ 'Active' | translate }}</h3>
    </div>
  </div>

</div>
</div>
